import Navbar from "./Navbar";
import Scroll from "./Scroll";
import UploadInTextarea from "./UploadInTextarea";
import ToggleShow from "./ToggleShow";
import ConsultationForm from "./ConsultationForm";
import Hub from "./Hub";

// document.addEventListener('DOMContentLoaded', _naja.initialize.bind(_naja));

window.addEventListener('DOMContentLoaded', () => {
    Navbar.init();
    Scroll.init();
    UploadInTextarea.init();
    ToggleShow.init();
    ConsultationForm.init();
    Hub.init();
});

window.addEventListener('scroll', () => {
});
